// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"41f2a473","787":"615b9c7f"}[chunkId] + ".chunk.js";
};